<template>
    <tr>
        <td>
            <select
                v-model="formLog.user_id"
                class="form-control"
                @change="saveLog"
            >
                <option
                    v-for="user in users"
                    :key="user.id"
                    :value="user.id"
                >
                    {{ user.name }}
                </option>
            </select>
            <error
                name="user_id"
                :errors="errors"
            />
        </td>
        <td>
            <vehicle-select
                v-model="formLog.vehicle_reg"
                :vehicles="vehicles"
                :loading="vehiclesLoading"
                optional
                :errors="errors"
                @change="saveLog"
            />
        </td>
        <td>
            <input
                type="text"
                class="form-control"
                v-model="formLog.location"
                @change="saveLog"
            >
            <error
                name="location"
                :errors="errors"
            />
        </td>
        <td>
            <date-picker
                v-model="formLog.start_time"
                @input="saveLog"
            />
            <error
                name="start_time"
                :errors="errors"
            />
        </td>
        <td>
            <date-picker
                v-model="formLog.end_time"
                @input="saveLog"
            />
            <error
                name="end_time"
                :errors="errors"
            />
        </td>
        <td>{{ duration | minsToHours }}</td>
        <td>{{ overtime | minsToHours }}</td>
        <td>
            <select
                v-model="formLog.out_of_hours"
                class="form-control"
                @change="saveLog"
            >
                <option :value="0">
                    No
                </option>
                <option :value="1">
                    Yes
                </option>
            </select>
        </td>
        <td>
            <select
                v-model="formLog.overnight_stay"
                class="form-control"
                @change="saveLog"
            >
                <option :value="0">
                    No
                </option>
                <option :value="1">
                    Yes
                </option>
            </select>
        </td>
        <td>
            <button
                @click="verify"
                v-if="!formLog.verified_by_id"
                class="btn btn-primary btn-sm"
            >
                Verify
            </button>
            <button
                @click="unverify"
                v-if="formLog.verified_by_id"
                class="btn btn-sm btn-danger"
            >
                Unverify
            </button>
            <p>
                <span v-if="formLog.verified_by">Verified by {{ formLog.verified_by.name }} </span>
            </p>
        </td>
        <td class="text-right">
            <span v-if="status">{{ status }}</span>
            <button
                class="btn btn-sm btn-danger"
                @click="deleteLog"
            >
                Delete
            </button>
            <p style="font-size: .8rem; margin: 0">
                {{ log.created_at | datetime }}
            </p>
        </td>
    </tr>
</template>

<script>
import DatePicker from "../../DateTimePickerComponent";
import VehicleSelect from "../../VehicleSelectComponent.vue";
import Service from "../../../services/OvertimeService";
import AuthService from "../../../services/AuthService";
export default {
    components: {
        DatePicker,
        VehicleSelect,
    },
    props: {
        log: {
            type: Object,
            required: true,
        },
        users: {
            type: Array,
            required: false,
            default: null,
        },
        vehicles: {
            type: Array,
            required: true,
        },
        vehiclesLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formLog: {},
            errors: {},
            status: null,
            canSave: false,
        };
    },
    computed: {
        duration() {
            return window
                .moment(this.formLog.end_time)
                .diff(window.moment(this.formLog.start_time), "minutes");
        },
        overtime() {
            return this.$store.getters["overtime/getOvertimeMins"](
                this.formLog
            );
        },
    },
    watch: {
        log: {
            handler: function (newLog) {
                this.formLog = {
                    ...newLog,
                    start_time: window.moment(newLog.start_time),
                    end_time: window.moment(newLog.end_time),
                };
            },
            immediate: true,
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.canSave = true;
        }, 500);
    },
    methods: {
        deleteLog() {
            if (
                !window.confirm(
                    "Are you sure you want to delete this overtime log?"
                )
            ) {
                return;
            }
            if (this.log.id) {
                Service.delete(this.log.id).then(() => {
                    this.$emit("deleted");
                });
            } else {
                this.$emit("deleted");
            }
        },
        saveLog() {
            if (!this.canSave) {
                return;
            }
            this.errors = {};
            this.status = "Saving...";
            Service.save(this.formLog)
                .then((res) => {
                    this.formLog = res.data;
                    this.$emit("saved", this.formLog);
                    this.status = "Saved";
                    window.setTimeout(() => {
                        this.status = null;
                    }, 1000);
                })
                .catch((err) => {
                    this.status = null;
                    this.errors = err.response.data.errors;
                });
        },
        verify() {
            this.formLog.verified_by_id = AuthService.user.id;
            this.saveLog();
        },
        unverify() {
            this.formLog.verified_by_id = null;
            this.saveLog();
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/overtime/RowComponent.vue